module.exports = __webpack_public_path__ + "media/images/signup-chad-wester-c365fe11692e528c6a874ab393a01b4e.jpg";